var LOG_PREFIX = '[Explorer Manual Production]';
function logManualProduction(message) {
  console.log("".concat(LOG_PREFIX, " ").concat(message));
}
function logManualProductionError(functionName, err) {
  var message = (err === null || err === void 0 ? void 0 : err.message) || String(err);
  console.error("".concat(LOG_PREFIX, " ERROR in ").concat(functionName, ": ").concat(message));
  if (err !== null && err !== void 0 && err.stack) {
    console.error("".concat(LOG_PREFIX, " stack: ").concat(err.stack));
  }
}
module.exports = {
  logManualProduction: logManualProduction,
  logManualProductionError: logManualProductionError
};